(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('FaqController', FaqController);

    FaqController.$inject = ['$scope', 'Principal', 'LoginService', '$state', '$sce', 'faqEntities', 'NasracWebContent'];

    function FaqController ($scope, Principal, LoginService, $state, $sce, faqEntities, NasracWebContent) {
    	var vm = this;
    	

		vm.account = null;
		vm.isAuthenticated = null;
		vm.login = LoginService.open;
		vm.register = register;
		$scope.$on('authenticationSuccess', function() {
			getAccount();
		});

		var entity = faqEntities[0];
		vm.nasrac_web_content = entity;
		vm.trustedHtml = $sce.trustAsHtml(entity.content);
		vm.tinymceModel = entity.content;

		vm.editMode = false;

		vm.tinymceOptions = {
			inline : false,
			plugins : [
			    'advlist autolink lists link image charmap print preview hr anchor pagebreak',
			    'searchreplace wordcount visualblocks visualchars code fullscreen',
			    'insertdatetime media nonbreaking save table contextmenu directionality',
			    'template paste textcolor colorpicker textpattern imagetools codesample toc'
			  ],
			toolbar : 'undo redo | fontselect | fontsizeselect | styleselect | bold italic | alignleft aligncenter alignright alignjustify | link bullist numlist outdent indent | print preview media fullpage | forecolor backcolor',
			fontsize_formats : '8pt 10pt 12pt 14pt 18pt 24pt 36pt',
			skin : 'lightgray',
			theme : 'modern',
			height : 600	
		};

		vm.updateContents = function() {
			entity.content = vm.tinymceModel;
			NasracWebContent.update(entity, onSaveSuccess, onSaveError);
			vm.editMode = false;
		};

		vm.cancelEditor = function() {
			vm.editMode = false;
		}

		vm.openEditor = function() {
			vm.editMode = true;
		}

		getAccount();

		function getAccount() {
			Principal.identity().then(function(account) {
				vm.account = account;
				vm.isAuthenticated = Principal.isAuthenticated;
			});
		}
		
		function register() {
			$state.go('register');
		}

		function onSaveSuccess(result) {
			vm.editMode = false;
			$state.go('faq', {}, {
				reload : true
			});
		}

		function onSaveError() {
			vm.editMode = true;
		}
    }
})();
